/**
 * @generated SignedSource<<612ffacce893c0dd56c8a180f5896aa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterColumnistItemAuthor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "entityLink">;
  readonly " $fragmentType": "newsletterColumnistItemAuthor";
};
export type newsletterColumnistItemAuthor$key = {
  readonly " $data"?: newsletterColumnistItemAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterColumnistItemAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterColumnistItemAuthor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "63b95610dd47f84f9912450c8d879a78";

export default node;
